/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, OnInit} from '@angular/core';
import {UIRouter} from '@uirouter/core';

import {FolioCopyModalComponent} from './folio-copy-modal.component';
import {AdminResourceCopyConfig} from '../common/controller/admin-resource-copy-config';
import {AdminResourceRouteContext, readAdminResourceRouteContext} from '../common/controller/admin-resource-route-context';

@Component({
  standalone: false,
  selector: 'adn-folio-context-route-page',
  template: `
    <adn-admin-resource-context-actions
      *ngIf="context"
      [model]="context.model"
      [modelComms]="context.modelComms"
      [isNew]="context.isNew"
      [readOnly]="context.readOnly"
      [confirmation]="confirmation"
      [copyConfig]="copyConfig">
    </adn-admin-resource-context-actions>
  `
})
export class FolioContextRoutePageComponent implements OnInit {
  context: AdminResourceRouteContext;

  readonly confirmation = {
    warningMessage: "The {{action}} of the Folio will also stop any of the Folio's Line Items from serving ads.",
    object: 'Folio'
  };

  readonly copyConfig: AdminResourceCopyConfig = {
    modalComponent: FolioCopyModalComponent,
    stateUrl: 'app.adv.folios.folio',
    lcase: 'folio',
    ucase: 'Folio'
  };

  constructor(private readonly uiRouter: UIRouter) {
  }

  ngOnInit(): void {
    this.context = readAdminResourceRouteContext(this.uiRouter);
  }
}
